<template>
  <div>
    <b-modal
      ref="modal"
      title="Editar Conta a Pagar"
      header-class="border-bottom-0"
      footer-class="border-top-0"
      size="lg"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <!-- form  -->
        <div class="row">
          <div class="col-md-12">
            <search-input
              :alias="form.vendor_id.alias"
              v-model="form.vendor_id.value"
              :displayedValue="form.name.value"
              :form="form"
              :name="'vendor_id'"
              @search="searchPerson($event)"
              :searchResult="persons"
              :isLoading="loading"
              @selected="setPerson($event)"
            >
              <search-input-option
                v-for="(row, index) in persons.data"
                :key="index"
                :index="index"
                @click="setPerson(row)"
              >
                <div>{{ row.name }}</div>
              </search-input-option>
            </search-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <text-input
              v-model="form.description.value"
              :alias="form.description.alias"
            />
          </div>
          <div class="col-6">
            <select-input
              v-model="form.account_plan_id.value"
              :alias="form.account_plan_id.alias"
              :options="accountPlanOptions"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Histórico:</label>
              <textarea
                v-model="form.history.value"
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <text-input v-model="form.document.value" alias="Documento" />
          </div>
          <div class="col-md-4 col-6">
            <number-input v-model="form.value.value" alias="Valor" />
          </div>
          <div class="col-md-4 col-6">
            <date-input v-model="form.due_date.value" alias="Vencimento" />
          </div>
        </div>
      </div>

      <br />

      <error-handler :error="error" />

      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
        >{{ alertData.message }}</b-alert
      >

      <!-- form  -->

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left:5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Form from "./../../../mixins/Form.js";
  import moment from "moment";

  export default {
    data: function() {
      return {
        form: new Form({
          id: {
            default: null
          },

          vendor_id: {
            alias: "Fornecedor"
          },

          name: {},

          description: {
            alias: "Descrição"
          },

          history: {},

          account_plan_id: {
            alias: "Plano de Contas",
            validate: {
              required: true
            },
            options: {}
          },
          document: {},
          value: {},
          due_date: {}
        }),

        selectedPerson: null,

        loading: false,

        error: null,

        alertData: {
          isVisible: false,
          message: null
        }
      };
    },

    computed: {
      billPayable() {
        return this.$store.state.billpayable.billPayable;
      },

      accountPlanOptions() {
        var options = {};

        for (let index in this.$store.state.account_plans) {
          options[
            this.$store.state.account_plans[index].id
          ] = this.$store.state.account_plans[index].description;
        }

        return options;
      },

      hasMoreThanOneParcelRow() {
        return this.parcels.length > 1;
      },

      persons() {
        return this.$store.state.person.persons;
      }
    },

    methods: {
      open(id) {
        this.resetForm();

        this.loadData(id);
      },

      loadData(id) {
        this.$store
          .dispatch("billpayable/getBillPayable", id)
          .then(response => {
            this.form.setValues(this.billPayable);
            this.$refs.modal.show();
          })
          .catch(error => {});
      },

      searchPerson(search) {
        this.loading = true;

        this.$store
          .dispatch("person/getPersons", {
            page: search.page,
            name: search.text,
            type: "v",
            status: 1
          })
          .then(response => {
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.error = error;
          });
      },

      setPerson(person) {
        this.selectedPerson = person;

        this.form.vendor_id.value = person.id;

        this.form.name.value = person.name;
      },

      resetForm() {
        this.error = null;

        this.alertData.isVisible = false;

        this.form.reset();
      },

      store() {
        this.$store.commit("showLoading");
        this.$store
          .dispatch("billpayable/putBillPayable", {
            form: this.form.getValues(),
            id: this.form.id.value
          })
          .then(response => {
            this.$refs.modal.hide();
            this.$emit("stored");
            this.$store.commit("showAlert", {
              message: "Lançamento Atualizado!",
              type: "success"
            });
            this.$store.commit("hideLoading");
          })
          .catch(error => {
            this.error = error;
            this.$store.commit("hideLoading");
          });
      }
    }
  };
</script>
